import React, { useState } from "react";
import { LogOut, User } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const UserProfileMenu = () => {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();

  const userName = localStorage.getItem("userName") || "User";
  const userId = localStorage.getItem("userId");

  const getInitials = (name) => {
    return name
      .split(" ")
      .filter(Boolean)
      .map((item) => item[0])
      .join("")
      .slice(0, 2)
      .toUpperCase();
  };

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userName");
    localStorage.removeItem("qrCode");
    localStorage.removeItem("doctorId");
    localStorage.removeItem("userId");

    toast.success("Logged out successfully");

    setTimeout(() => {
      window.location.href = "/";
    }, 2000);
  };

  return (
    <div
      className="relative"
      onMouseEnter={() => setShowMenu(true)}
      onMouseLeave={() => setShowMenu(false)}
    >
      {/* Profile */}
      <div className="flex items-center gap-3 cursor-pointer">

        <div
          className="
            w-10
            h-10
            rounded-full
            bg-[#eeeafd]
            text-[#1D3A73]
            flex
            items-center
            justify-center
            font-bold
            text-xs
            flex-shrink-0
          "
        >
          {getInitials(userName)}
        </div>

        <div className="hidden sm:block">
          <p className="text-sm font-semibold text-gray-800">
            {userName}
          </p>

          <p className="text-[11px] text-gray-400">
            {userId ? `ID: ${userId}` : "Student"}
          </p>
        </div>

      </div>

      {/* Dropdown */}
      {showMenu && (
        <div className="absolute right-0 top-full z-50 pt-2">

          <div
            className="
              w-52
              bg-white
              rounded-2xl
              shadow-xl
              border
              border-gray-100
              p-2
            "
          >

            {/* User Info */}
            <div className="px-3 py-2 border-b border-gray-100 mb-1">

              <p className="text-xs font-semibold text-gray-800">
                {userName}
              </p>

              <p className="text-[10px] text-gray-400 mt-0.5">
                Student
              </p>

            </div>

            {/* Profile */}
            {/* <button
              type="button"
              onClick={() => navigate("/profile")}
              className="
                w-full
                flex
                items-center
                gap-3
                px-3
                py-2.5
                rounded-xl
                text-sm
                text-gray-600
                hover:bg-gray-50
                transition
              "
            >
              <User size={16} />

              <span>Profile</span>
            </button> */}

            {/* Logout */}
            <button
              type="button"
              onClick={handleLogout}
              className="
                w-full
                flex
                items-center
                gap-3
                px-3
                py-2.5
                rounded-xl
                text-sm
                text-red-500
                hover:bg-red-50
                transition
              "
            >
              <LogOut size={16} />

              <span>Logout</span>
            </button>

          </div>

        </div>
      )}
    </div>
  );
};

export default UserProfileMenu;